// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"670":"d2c70ed3","770":"571021e3"}[chunkId] + ".chunk.js";
};